export const visibility = {
  GLOBAL: 'GLOBAL',
  SUBSCRIPTION: 'SUBSCRIPTION',
};
